/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Telegram_Mock_Btn_EditInputs */

const tr_landing_telegram_mock_btn_edit = /** @type {(inputs: Landing_Telegram_Mock_Btn_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Düzenle`)
};

const en_landing_telegram_mock_btn_edit = /** @type {(inputs: Landing_Telegram_Mock_Btn_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit`)
};

const de_landing_telegram_mock_btn_edit = /** @type {(inputs: Landing_Telegram_Mock_Btn_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bearbeiten`)
};

const ru_landing_telegram_mock_btn_edit = /** @type {(inputs: Landing_Telegram_Mock_Btn_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменить`)
};

/**
* | output |
* | --- |
* | "Edit" |
*
* @param {Landing_Telegram_Mock_Btn_EditInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_telegram_mock_btn_edit = /** @type {((inputs?: Landing_Telegram_Mock_Btn_EditInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Telegram_Mock_Btn_EditInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_telegram_mock_btn_edit(inputs)
	if (locale === "de") return de_landing_telegram_mock_btn_edit(inputs)
	if (locale === "ru") return ru_landing_telegram_mock_btn_edit(inputs)
	return tr_landing_telegram_mock_btn_edit(inputs)
});